<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back"><mat-icon
            color="primary">arrow_back_ios</mat-icon></button>
    <h3>{{ patient | patientHeading:'Admit':'Admit Patient' }}</h3>
    <div>

        <button mat-icon-button [disabled]="form.invalid" (click)="admitPatient()" matTooltip="Admit Patient"><mat-icon
                [color]="form.invalid ? '' : 'primary'">save</mat-icon></button>
    </div>
</mat-toolbar>
<div id="top"></div>

<div class="admit-details-container">
    <form [formGroup]="form">
        <mat-card>

            <mat-form-field appearance="outline">
                <mat-label>Admission Date</mat-label>
                <input matInput [matDatepicker]="admissionDatePicker" formControlName="admissionDate"
                    placeholder="DD/MM/YYYY" [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="admissionDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #admissionDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Hospital</mat-label>
                <mat-select formControlName="hospitalId" (selectionChange)="selectHospital($event)">
                    <mat-option *ngFor="let hospital of hospitals" [value]="hospital.id">{{hospital.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="form.get('hospitalId')?.value">
                <mat-label>Ward</mat-label>
                <mat-select formControlName="wardId">
                    <mat-option *ngFor="let ward of wards" [value]="ward.id">{{ward.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Bed</mat-label>
                <input matInput formControlName="bed">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Admission Type</mat-label>
                <mat-select formControlName="admissionType">
                    <mat-option value="Day Case Admission">Day Case Admission</mat-option>
                    <mat-option value="Elective Admission">Elective Admission</mat-option>
                    <mat-option value="Emergency Admission">Emergency Admission</mat-option>
                    <mat-option value="Expedited Admission">Expedited Admission</mat-option>
                    <mat-option value="Urgent Admission">Urgent Admission</mat-option>
                    <mat-option value="EMU Admission">EMU Admission</mat-option>
                </mat-select>
            </mat-form-field>

            <div class="field-with-action">
                <mat-form-field appearance="outline">
                    <mat-label>Diagnosis/Active Problem</mat-label>
                    <textarea matInput cdkTextareaAutosize="true" formControlName="diagnosis"></textarea>
                </mat-form-field>
                <button mat-icon-button matTooltip="Add additional diagnosis" (click)="addDiagnosisField()"
                    *ngIf="visibleDiagnosisFields.length <= 24" color="primary"><mat-icon>add</mat-icon></button>
            </div>

            <ng-container *ngFor="let field of visibleDiagnosisFields; let i = index">
                <mat-form-field appearance="outline">
                    <mat-label>Diagnosis/Active Problem {{ i + 2 }}</mat-label>
                    <textarea matInput cdkTextareaAutosize="true" [formControlName]="field"></textarea>
                </mat-form-field>
            </ng-container>

            <mat-form-field appearance="outline">
                <mat-label>Admission Summary</mat-label>
                <textarea matInput cdkTextareaAutosize="true" formControlName="admissionSummary"></textarea>
            </mat-form-field>


            <app-icd-code-selector [patientSex]="icdCodingSex" [patientAge]="icdCodingAge" [defaultOnsetDate]="icdDefaultOnsetDate" [initialCodes]="selectedIcdCodes"
                (codesChanged)="onIcdCodesChanged($event)"></app-icd-code-selector>

            <!-- B3 — the real records, checked for coverage against the admission date being
                 captured rather than today. -->
            <app-authorization-list *ngIf="patient?.id" [patientId]="patient.id" [groupId]="groupId"
                [dateOfService]="form.get('admissionDate')?.value"></app-authorization-list>

        </mat-card>

    </form>
</div>